import { render } from "./wf-ssq.vue?vue&type=template&id=9a4f470a&scoped=true"
import script from "./wf-ssq.vue?vue&type=script&lang=js"
export * from "./wf-ssq.vue?vue&type=script&lang=js"

import "./wf-ssq.vue?vue&type=style&index=0&id=9a4f470a&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a4f470a"]])

export default __exports__